let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Z0n9")).then(() => parcelRequire('ljCya'));